import { date, object, string, TypeOf } from 'yup';

export const HistoryTemplateFilterSchema = object({
  invoiceNumber: string(),
  paymentVoucher: string(),
  area: string(),
  projects: string(),
  publicServices: string(),
  grouping: string(),
  dateRange: object({
    startDate: date().required(),
    endDate: date().required(),
  }).required(),
});

export type HistoryTemplateFilterType = TypeOf<
  typeof HistoryTemplateFilterSchema
>;
